import { IEvent } from "../types";

const eventComparator = (a: IEvent, b: IEvent) => a.id.localeCompare(b.id);

export default eventComparator;
